var _g, _path, _g2, _path2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampfirePoints30(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 150,
    viewBox: "15 20 100 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.7577 161.718C67.7577 161.718 85.4854 159.723 95.3071 152.244C105.129 144.764 115.904 130.549 114.707 111.602C113.51 92.656 108.957 88.414 108.957 88.414C108.957 88.414 106.082 99.6358 101.531 97.6391C96.9793 95.6424 103.452 63.0233 95.3071 51.3004C87.1622 39.5776 64.1597 20.5068 64.1597 20.5068C64.1597 20.5068 65.3493 52.7512 59.8394 56.2426C54.3295 59.7339 51.2233 64.2282 48.8281 69.4647C46.4328 74.7012 47.155 104.783 39.0054 104.783C30.8558 104.783 29.4235 86.9194 29.4235 86.9194C29.4235 86.9194 18.4028 103.125 18.8824 114.843C19.362 126.561 34.2187 145.263 34.2187 145.263L26.0737 143.522C26.0737 143.522 39.2452 161.718 67.7577 161.718Z",
    fill: "url(#paint0_radial)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2537 85.0132C37.2537 85.0132 41.9006 76.27 42.3499 71.7485C42.7991 67.227 41.1041 58.0504 40.532 58.8949C33.923 68.265 34.9928 75.2027 37.2537 85.0132Z",
    fill: "#FF6320"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.2161 156.522C61.2161 156.522 75.2065 160.354 87.1725 150.007C94.2308 143.956 100.594 137.077 106.136 129.506L96.5629 131.999C96.5629 131.999 96.377 121.842 98.7704 115.711C101.164 109.581 101.347 104.78 91.712 111.894C90.474 112.808 81.4655 110.153 83.6749 94.8271C85.8842 79.5017 80.9134 64.7412 72.63 55.9321C72.63 64.363 53.8547 74.9008 52.9327 90.2281C52.0106 105.556 50.5541 134.491 30.1123 113.22C30.1123 133.721 46.1215 154.605 61.2161 156.522Z",
    fill: "#FE9A3D"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5347 153.457C72.1973 156.404 89.2159 147.741 90.1221 135.254C91.5953 128.166 91.2273 123.95 86.9935 120.119C75.5248 110.316 73.2829 83.466 75.3965 71.895C53.1413 93.879 68.1569 104.245 55.7001 119.736C49.0711 124.718 38.2103 122.801 37.2901 126.058C36.3699 129.316 51.4645 152.691 64.5347 153.457Z",
    fill: "#FFB22D"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.1265 151.929C77.3366 151.77 84.7826 139.092 83.3103 132.388C81.838 125.684 71.7143 117.245 70.9781 109.198C70.242 101.151 70.7922 97.7646 70.7922 97.7646C70.7922 97.7646 65.6457 107.666 64.0768 113.988C62.5079 120.31 60.8515 129.316 57.1699 130.465C53.4883 131.615 47.4105 129.316 48.8855 132.573C50.3606 135.831 56.9942 152.117 68.1265 151.929Z",
    fill: "#FFE840"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.1241 149.8C75.3804 149.8 77.9532 139.263 77.2933 134.682C76.6334 130.101 67.5394 122.541 68.1241 120.251C68.7087 117.96 66.5096 130.787 62.5472 132.62C58.5849 134.452 54.6244 135.135 56.1646 139.262C57.7047 143.389 61.5416 149.8 68.1241 149.8Z",
    fill: "#FDFBE6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.867188,
    y: 0.506836,
    width: 131.931,
    height: 177.211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.793167 0 0 0 0 0.391667 0 0 0 0.76 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 19.1123,
    y: 46.9321,
    width: 98.0242,
    height: 123.283,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.443137 0 0 0 0 0.231373 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 44.6592,
    y: 93.7646,
    width: 42.8377,
    height: 62.166,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.909804 0 0 0 0 0.25098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f",
    x: 50.8242,
    y: 114.978,
    width: 31.5686,
    height: 39.822,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.8328 97.7642) rotate(-73.1871) scale(47.5604 38.205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F87A1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F83D1F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampfirePoints30);
export default __webpack_public_path__ + "static/media/campfire-points-30.e113c12f6399b6348555b73c39ed570a.svg";
export { ForwardRef as ReactComponent };